import PropTypes from 'prop-types';
import { Component } from 'react';
/*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
import { EVENTS, ACTIONS } from '../../../tracking/events';
import { memoizedRetrieveSchema } from '../utils/schemaUtils';
import { memoizedGetDefaultFormState } from '../utils/defaults';
import SchemaField from './fields/SchemaField';
import validateFormData, { toErrorList } from '../utils/validate';
import { toIdSchema } from '../utils/idUtils';
import { jsx as _jsx } from "react/jsx-runtime";
class ParamForm extends Component {
  /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
  constructor(props) {
    super(props);
    this.onChange = (formData, newErrorSchema) => {
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      const {
        liveValidate,
        noValidate
      } = this.props;
      const mustValidate = !noValidate && liveValidate;
      let state = {
        formData
      };
      if (mustValidate) {
        /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
        const {
          errors,
          errorSchema
        } = this.validate(formData);
        /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
        state = Object.assign({}, state, {
          errors,
          errorSchema
        });
      } else if (!noValidate && newErrorSchema) {
        state = Object.assign({}, state, {
          /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
          errorSchema: newErrorSchema,
          errors: toErrorList(newErrorSchema)
        });
      }
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      this.tracker.track(EVENTS.PARAM_FORM_INTERACTION, {
        action: ACTIONS.MODIFY_FIELD_VALUE,
        /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
        paramType: this.props.schemaGroup
      });
      this.setState(state, () => {
        /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
        if (this.props.onChange) {
          /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
          this.props.onChange(state);
        }
      });
    };
    this.state = this.getState(); /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    this.tracker = props.usageTracker;
  }
  getState() {
    const state = this.state || {};
    /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    const {
      liveValidate,
      noValidate,
      schema
    } = this.props;
    /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    const edit = typeof this.props.formData !== 'undefined';
    const mustValidate = edit && !noValidate && liveValidate;
    const {
      definitions
    } = schema;
    const formData = memoizedGetDefaultFormState(schema, /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    this.props.formData, definitions);
    /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    const {
      errors,
      errorSchema
    } = mustValidate ? this.validate(formData, schema) : {
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      errors: state.errors || [],
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      errorSchema: state.errorSchema || {}
    };
    return {
      errors,
      errorSchema,
      formData
    };
  }
  getIdSchema() {
    /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    const {
      schema
    } = this.props;
    const {
      definitions
    } = schema;
    const retrievedSchema = memoizedRetrieveSchema(schema, definitions, /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    this.state.formData);
    const idSchema = toIdSchema(retrievedSchema, null, definitions, /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    this.state.formData, /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    this.props.idPrefix);
    return idSchema;
  }
  getRegistry() {
    return {
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      definitions: this.props.schema.definitions || {},
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      formContext: this.props.formContext || {}
    };
  }

  /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
  validate(formData, schema = this.props.schema) {
    const {
      definitions
    } = this.getRegistry();
    const resolvedSchema = memoizedRetrieveSchema(schema, definitions, formData);
    /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    return validateFormData(formData, resolvedSchema);
  }

  /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */

  render() {
    /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    const {
      idPrefix,
      schema,
      schemaGroup
    } = this.props;
    /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    const {
      formData,
      errorSchema
    } = this.state;
    const registry = this.getRegistry();
    const idSchema = this.getIdSchema();
    return /*#__PURE__*/_jsx(SchemaField
    /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */, {
      errorSchema: errorSchema,
      formData: formData,
      idPrefix: idPrefix,
      idSchema: idSchema,
      onChange: this.onChange,
      registry: registry,
      schema: schema,
      schemaGroup: schemaGroup
    });
  }
}

/*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
ParamForm.propTypes = {
  idPrefix: PropTypes.string,
  formContext: PropTypes.object,
  formData: PropTypes.any,
  liveValidate: PropTypes.bool,
  noValidate: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  schema: PropTypes.object.isRequired,
  schemaGroup: PropTypes.string,
  usageTracker: PropTypes.object.isRequired
};

/*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
ParamForm.defaultProps = {
  liveValidate: false,
  noValidate: false
};
export default ParamForm;